import type {
  FetchLatestResourcesPageableQuery,
  FetchLatestResourcesPageableQueryVariables,
  FetchLatestResourcesQuery,
  FetchLatestResourcesQueryVariables,
  Resource,
  ResourceQuery,
} from '@edwin-group/cj-graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_FETCH_LATEST_RESOURCES, QUERY_FETCH_RESOURCES_PAGEABLE, QUERY_RESOURCE } from '@edwin-group/cj-graphql';
import { Pagination } from '@/components/SeachTab';

export const fetchResource = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ResourceQuery>({
      query: QUERY_RESOURCE,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resource: null };
  }

  if (!data?.resources?.data.length) {
    return { resource: null };
  }

  return {
    resource: data?.resources?.data[0],
  };
};

export const fetchRelatedContent = async (slug: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchLatestResourcesQuery, FetchLatestResourcesQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES,
      fetchPolicy: 'cache-first',
      variables: {
        slug: [slug],
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resource: null };
  }

  return {
    resources: data?.resources?.data as Resource[],
  };
};

export interface SearchTabFilters {
  kinds?: string[];
  search?: string;
  trait?: string;
  subTrait?: string;
}

export const fetchResourcePageable = async (page: number, filters: SearchTabFilters) => {
  const apolloClient = initializeApollo();

  const { kinds, search, trait, subTrait } = filters;

  const { data, error } = await requestHandler(
    apolloClient.query<FetchLatestResourcesPageableQuery, FetchLatestResourcesPageableQueryVariables>({
      query: QUERY_FETCH_RESOURCES_PAGEABLE,
      fetchPolicy: 'cache-first',
      variables: {
        page,
        kinds: kinds?.length === 0 ? undefined : kinds,
        search,
        trait: trait === 'null' ? undefined : trait,
        subTrait: subTrait === 'null' ? undefined : subTrait,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: [], pagination: {} as Pagination };
  }

  if (!data?.resources?.data.length) {
    return { resources: [], pagination: {} as Pagination };
  }

  return {
    resources: data?.resources?.data,
    pagination: data?.resources?.meta.pagination as Pagination,
  };
};
